import { render, staticRenderFns } from "./moduleBeneficiaryExpired.vue?vue&type=template&id=7760125a"
import script from "./moduleBeneficiaryExpired.vue?vue&type=script&lang=js"
export * from "./moduleBeneficiaryExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports